/*
 * @providesModule SKZFraudPrompt
 */

import _ from 'lodash';

type IdCheckType= 'NAME' | 'ADDRESS' | 'ID' | 'UTILITY' | 'SMS';
type IdCheckStatus= 'OPEN' | ' SUBMITTED' | 'CANCELED';

export class FraudPromptRecord {
 id:                      string;
 type:                    IdCheckType;
 status:                  IdCheckStatus;

 sms_code:                string;
 id_front_url:            string;
 id_back_url:             string;
 utility_url:             string;
 created_at:              string;
 expires_at:              string;
 submitted_at:            string;
 name:                    string;
 street:                  string;
 city:                    string;
 state:                   string;
 zip:                     string;
 country:                 string;
 phone:                   string;
}

export default class FraudPrompt extends FraudPromptRecord {

  constructor(keyValueSource: Object) {
    super();
    return _.create(FraudPrompt.prototype, keyValueSource);
  }

  isPromptOpen(): boolean {
    return this.status == 'OPEN';
  }

  isPromptSubmitted(): boolean {
    return this.status == 'SUBMITTED' && this.submitted_at;
  }

  isPromptCanceled(): boolean {
    return this.status == 'CANCELED';
  }

  isNamePrompt(): boolean {
    return this.type == 'NAME';
  }

  isAddressPrompt(): boolean {
    return this.type == 'ADDRESS';
  }

  isIdPrompt(): boolean {
    return this.type == 'ID';
  }

  isUtilityPrompt(): boolean {
    return this.type == 'UTILITY';
  }

  isSMSPrompt(): boolean {
    // sms_resend is a locally set variable for showing the resend prompt
    return this.type == 'SMS' && !this.sms_resend;
  }

  getPromptId(): string {
    return this.id;
  }

}
